import React, { useEffect, useMemo, useState } from "react";
import style from "../calculator.module.css";
const LAY_LABEL = "Lay (Contra)";
const LAY_RE = /lay\s*\(contra\)/i;
const stripLay = (s) => s.replace(LAY_RE, "").replace(/\s{2,}/g, " ").trim();
const hasLay = (s) => LAY_RE.test(s);
const addLayIfMissing = (s) => {
  if (hasLay(s)) return s;
  const base = s.trim();
  return base ? `${base} ${LAY_LABEL}` : LAY_LABEL;
};
const ensureCount = (arr, count, makeNewBet) => {
  let out = [...arr];
  if (out.length < count) {
    for (let i = out.length; i < count; i++) out.push(makeNewBet(i));
  } else if (out.length > count) {
    out = out.slice(0, count);
  }
  return out;
};
const MODE_LABELS = [
  "",
  "CALCULADORA DE EXTRAÇÃO COM EXCHANGE LAY",
  "CALCULADORA DE LUCRO DIRETO",
  "CALCULADORA DE EXTRAÇÃO COM 3 CASAS"
];
const detectMode = (dataOperation, typeSurebet) => {
  const count = dataOperation.length;
  const noneHaveLay = dataOperation.every((b) => !hasLay(b.market_event));
  const secondHasLay = count >= 2 && !hasLay(dataOperation[0].market_event) && hasLay(dataOperation[1].market_event);
  if (count === 2 && secondHasLay && typeSurebet === "bonus_bookmaker") {
    return "CALCULADORA DE EXTRAÇÃO COM EXCHANGE LAY";
  }
  if (count === 2 && noneHaveLay && typeSurebet === "") {
    return "CALCULADORA DE LUCRO DIRETO";
  }
  if (count === 3 && noneHaveLay && typeSurebet === "bonus_bookmaker") {
    return "CALCULADORA DE EXTRAÇÃO COM 3 CASAS";
  }
  return "";
};
const applyMode = (params) => {
  const { mode, dataOperation, startCalcFormulaLay, setTypeSurebet, makeNewBet, setItemCount } = params;
  if (mode === "") {
    return;
  }
  const clone = dataOperation.map((b) => ({ ...b }));
  const applyNoLay = (b) => {
    b.market_event = stripLay(b.market_event);
  };
  const applyYesLay = (b) => {
    b.market_event = addLayIfMissing(b.market_event);
  };
  if (mode === "CALCULADORA DE EXTRAÇÃO COM EXCHANGE LAY") {
    let next = ensureCount(clone, 2, makeNewBet);
    applyNoLay(next[0]);
    applyYesLay(next[1]);
    startCalcFormulaLay(next, "bonus_bookmaker");
    setTypeSurebet("bonus_bookmaker");
    setItemCount(next.length);
    return;
  }
  if (mode === "CALCULADORA DE LUCRO DIRETO") {
    let next = ensureCount(clone, 2, makeNewBet);
    applyNoLay(next[0]);
    applyNoLay(next[1]);
    startCalcFormulaLay(next, "");
    setTypeSurebet("");
    setItemCount(next.length);
    return;
  }
  if (mode === "CALCULADORA DE EXTRAÇÃO COM 3 CASAS") {
    let next = ensureCount(clone, 3, makeNewBet);
    next.forEach(applyNoLay);
    startCalcFormulaLay(next, "bonus_bookmaker");
    setTypeSurebet("bonus_bookmaker");
    setItemCount(next.length);
    return;
  }
};
const FormulaModeSelect = ({
  dataOperation,
  startCalcFormulaLay,
  typeSurebet,
  setTypeSurebet,
  statusMode,
  setItemCount,
  setEditingValues
}) => {
  const defaultFactory = useMemo(
    () => (index) => ({
      bet_home_name: `Casa ${index + 1}`,
      market_event: `Mercado ${index + 1}`,
      info_market_event: `Info Mercado ${index + 1}`,
      commission: 0,
      chance: 3,
      stake: 0,
      backStake: 0,
      block_chance: false,
      block_stake: false,
      profit: 0
    }),
    []
  );
  const factory = defaultFactory;
  const [selected, setSelected] = useState("");
  useEffect(() => {
    if (!selected) {
      const detected = detectMode(dataOperation, typeSurebet);
      if (detected) setSelected(detected);
    }
  }, [dataOperation, typeSurebet]);
  const onChange = (e) => {
    const value = e.target.value;
    setSelected(value);
    setEditingValues({});
    applyMode({
      mode: value,
      dataOperation,
      startCalcFormulaLay,
      setTypeSurebet,
      makeNewBet: factory,
      setItemCount
    });
  };
  return (
    <select value={selected} onChange={onChange} className={`form-select ${statusMode ? `${style.calculator_border_color_dark} ${style.calculator_formula_mode_s_text_dark_mode}  ${style.calculator_formula_mode_select_bg_dark}` : ""}`}>
      {MODE_LABELS.map((label) => (
        <option key={label || "empty"} value={label}>
          {label}
        </option>
      ))}
    </select>
  );
};
export {
  FormulaModeSelect,
  LAY_LABEL,
  addLayIfMissing,
  applyMode,
  detectMode,
  ensureCount,
  hasLay,
  stripLay
};